/** Mirrors backend `com.kervolt.oms.merch.qc` (buying-house D3). */
export type QcInspectionType = 'INLINE' | 'PRE_FINAL' | 'FINAL' | 'BUYER_THIRD_PARTY';
export type QcInspectionStatus = 'SCHEDULED' | 'PASSED' | 'FAILED' | 'CANCELLED';
export type DefectSeverity = 'CRITICAL' | 'MAJOR' | 'MINOR';
export type InspectionLevel = 'I' | 'II' | 'III';

export const QC_TYPE_LABELS: Record<QcInspectionType, string> = {
    INLINE: 'Inline', PRE_FINAL: 'Pre-final', FINAL: 'Final', BUYER_THIRD_PARTY: 'Buyer / third party',
};
export const QC_STATUS_LABELS: Record<QcInspectionStatus, string> = {
    SCHEDULED: 'Scheduled', PASSED: 'Passed', FAILED: 'Failed', CANCELLED: 'Cancelled',
};
export const SEVERITY_LABELS: Record<DefectSeverity, string> = { CRITICAL: 'Critical', MAJOR: 'Major', MINOR: 'Minor' };
export const INSPECTION_LEVELS: InspectionLevel[] = ['I', 'II', 'III'];
export const SUPPORTED_AQLS = ['0.65', '1.0', '1.5', '2.5', '4.0', '6.5'];

export interface IQcDefect { defectName: string; severity: DefectSeverity; defectCount: number }

export interface IQcInspection {
    id: string;
    buyerOrderId: string;
    orderNumber?: string | null;
    styleId?: string | null;
    styleNumber?: string | null;
    inspectionType: QcInspectionType;
    scheduledDate: string;
    inspectedDate?: string | null;
    inspectorUserId?: string | null;
    inspectorName?: string | null;
    lotSize: number;
    inspectionLevel: InspectionLevel;
    aqlMajor: number;
    aqlMinor: number;
    sampleSize: number;
    codeLetter: string;
    fullInspection: boolean;
    majorAccept: number;
    minorAccept: number;
    criticalFound: number;
    majorFound: number;
    minorFound: number;
    status: QcInspectionStatus;
    resultRemarks?: string | null;
    reinspectionOfId?: string | null;
    reinspectionId?: string | null;
    defects: IQcDefect[];
}

export interface IQcPage { content: IQcInspection[]; totalElements: number; number: number; size: number }

export interface IQcSummary { scheduled: number; passed: number; failed: number; cancelled: number; passRatePercent: number | null }

export interface IQcPlanPreview {
    lotSize: number;
    inspectionLevel: InspectionLevel;
    aqlMajor: number;
    aqlMinor: number;
    codeLetter: string;
    sampleSize: number;
    fullInspection: boolean;
    majorAccept: number;
    majorReject: number;
    minorAccept: number;
    minorReject: number;
    criticalAccept: number;
}

export interface IQcBookingRequest {
    buyerOrderId: string;
    styleId?: string | null;
    inspectionType: QcInspectionType;
    scheduledDate: string;
    inspectorUserId?: string | null;
    inspectorName?: string | null;
    lotSize: number;
    inspectionLevel?: InspectionLevel;
    aqlMajor?: number;
    aqlMinor?: number;
}

export interface IQcResultRequest {
    inspectedDate: string;
    inspectorName?: string | null;
    defects: IQcDefect[];
    resultRemarks?: string | null;
}

export interface IQcFilters {
    buyerOrderId?: string;
    type?: QcInspectionType;
    status?: QcInspectionStatus;
    from?: string;
    to?: string;
}
